import { submitFilterDTO, IReportData, IColumn, IDataTypes, filterDTO } from "./types"
import { Column } from "react-table"
import moment from 'moment';
import { SecondsToTimeFormat } from "src/helpers/AppCode";
import { isEmptyArray } from "src/helpers/typeChecker/typeChecker";
import { useTranslation } from "react-i18next";

export const convertApiDataToReactTableData = (obj: IReportData | unknown): Array<object> => {
    const objIData = obj as unknown as IReportData;
    const tmpData: Array<object> = [];
   
    if (objIData === undefined || objIData === null) return tmpData;

    if (isEmptyArray(objIData)) return tmpData;

    if(!objIData.reportData) return tmpData;
    
    objIData.reportData.map((data: any) => {
        tmpData.push((data))
    })
    return tmpData;
}
//--convertApiDataToReactTableData

export const convertApiHeaderToReactTableHeader = (obj: any[], dataTypes: IDataTypes[]): Array<Column<object>> => {
    const objIcolumn = obj as unknown as IColumn [];
    let tmpHeaders: Array<Column<object>> = [];
    let tmpHeader: any;

    tmpHeaders = objIcolumn.map((header: IColumn) => {
        tmpHeader = {
            id: header.columnName,
            Header: header.columnDisplayName,
            accessor: header.columnName,
            isVisible: header.visible,
            order: header.columnOrder,
            isDraggable: header.isDraggable == undefined ? true : header.isDraggable,
            Footer: header.columnFooter ? header.columnFooter : "",
            Cell: ({ value }: any) => { return FormatCell(header.columnDataType, value, dataTypes) }
        }

        return tmpHeader
    })
    return tmpHeaders;
}
//--convertApiHeaderToReactTableHeader

export const isFiltersNullOrEmpty = (filters: submitFilterDTO | undefined): boolean => {
    let isEmpty = true;
    if(filters)
        if(filters.filters[0].length > 0)
            isEmpty = false;
    return isEmpty;
}
//--isFiltersNullOrEmpty

export const isFilterUserTypedValueEmptyArray = (filter: filterDTO): boolean => {
    return filter.userValues.length == 0 || filter.userValues[0] == "";
}
//--isFilterUserTypedValueEmptyArray

const FormatCell = (headerType: any, dataValue: any, dataTypes: IDataTypes[]) => {
    const { t } = useTranslation();
    
    if (!dataValue || dataValue === "UNKNOWN" || dataValue === null) {
        return getDefaultVaule(headerType, dataTypes);
    }

    if (isDate(headerType, dataTypes)) {
        return dateFormatConverter(dataValue, headerType, dataTypes);
    }
    
    else if (headerType === "Boolean") {
        return dataValue.toString();
    }

    return t(dataValue);  
}
//--FormatCell

const getDefaultVaule = (headerType: string, dataTypes: IDataTypes[] ): string => {
    let defaultValue = "-";

    dataTypes.map((dataType: IDataTypes) => {
        if (dataType.apiType == headerType && (dataType.frontType == "number")) {
            defaultValue = dataType.defaultEmptyValue == 0 || dataType.defaultEmptyValue ? `${dataType.defaultEmptyValue}` : defaultValue;
        }
    })
    return defaultValue;
}

const dateFormatConverter = (value: any, type: string, dataTypes: IDataTypes[]) =>{
    let finaleDate = null;
    finaleDate = dataTypes.map((dataType: IDataTypes) => {
        if (dataType.apiType == type && type == "Date" && dataType.frontType == "date" && dataType.frontDisplayFormat != "") {
            const date = moment(value, dataType.sourceDisplayFormat)
            return moment(date).format(dataType.frontDisplayFormat);
        }
        else if (dataType.apiType == type && type == "IntegerTime" && dataType.frontType == "date" && dataType.frontDisplayFormat != "") {
            return SecondsToTimeFormat(value, dataType.sourceDisplayFormat, dataType.frontDisplayFormat);
        }
    })
    return finaleDate;
}
//--dateFormatConverter

const isDate = (type: string, dataTypes: IDataTypes[]): boolean => {
    let condition = false
    dataTypes.map((dataType: IDataTypes) => {
        if (dataType.apiType == type && dataType.frontType == "date" && dataType.frontDisplayFormat != "") {
            condition = true;
        }
    })
    return condition;
}
//--isDate